function accordian(){
  const accordions = document.querySelectorAll(".accordian-wrap");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector(".accordian-content");
    accordion.classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";
    setTimeout(function(){
      content.style.maxHeight = content.scrollHeight + "px";
    },100)
  };
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector(".accordian-content");
    accordion.classList.remove("active");
    content.style.maxHeight = null;
  };
  // var first_accordian = document.querySelector(".accordian-wrap");
  // if(first_accordian){
  //   var first_content = first_accordian.querySelector(".accordian-content");    
  // }
  // if(first_content){
  //   first_content.style.maxHeight = first_content.scrollHeight + "px";
  // }
  
  // if(document.querySelector('.wear_it_acc') != null){
  //   var last_accordions = accordions[accordions.length-1];
  //   console.log(last_accordions);
  //   if(last_accordions){
  //     var last_content = last_accordions.querySelector(".accordian-content");    
  //   }
  //   if(last_content){
  //     last_content.style.maxHeight = last_content.scrollHeight + "px";
  //      last_accordions.classList.add("active");
  //   }
  // }
  accordions.forEach((accordion , index) => {
    const intro = accordion.querySelector(".accordian-title");
    const content = accordion.querySelector(".accordian-content");
    intro.onclick = () => {
      if (content.style.maxHeight) {
        closeAccordion(accordion);
      } else {
        accordions.forEach((accordion) => closeAccordion(accordion));
        openAccordion(accordion);


      }
    };
  });
}
accordian();
document.addEventListener("shopify:section:load", function(event) {
  accordian();
});